const $ = require( 'jquery' );
window.jQuery = $;
window.$ = $;

require( './vendor/jquery-ui-1.11.4.min' );

require( 'bootstrap' );
require( 'jquery.cookie' );
require( 'node-waves' );
require( 'owl.carousel' );
require( 'slick-carousel' );
require( 'magnific-popup' );
require( 'lightgallery' );
require( 'what-input' );
require( 'jquery-parallax.js' );
require( 'bootstrap-notify' );

require( './elements/loader' );
require( './elements/cookies' );
require( './elements/lazyload' );
require( './elements/scroll-reveal' );
require( './elements/skrollr' );

import { Navbar } from './elements/navbar.js';
import { SliderManager } from './elements/slider-manager.js';
import { MagnificPopup } from './elements/magnific-popup';
import { LightGallery } from './elements/light-gallery';
import { Portfolio } from './elements/portfolio';

(() => {
    new Navbar();
    new SliderManager();
    new MagnificPopup();
    new LightGallery();
    new Portfolio();

    Waves.init();
})();
